// 통검/쇼검 최근검색어 타입과 맞추기 위해 소문자로 정의
export enum SuggestionType {
  WINDOW = 'window',
  KEYWORD = 'keyword',
  MALL = 'mall',
  PLAN = 'plan',
  CATEGORY = 'category',
}

const SuggestionSubTitles = {
  WINDOW: '',
  KEYWORD: '',
  MALL: '몰 상품보기',
  PLAN: '기획전',
  CATEGORY: '카테고리',
}

const SuggestionNclicks = {
  WINDOW: 'gowindow',
  KEYWORD: 'keyword',
  MALL: 'mallview',
  PLAN: 'event',
  CATEGORY: 'category',
}

export const getSubTitle = (type: SuggestionType | string) => {
  return SuggestionSubTitles[type.toUpperCase()]
}

export const getNclick = (type: SuggestionType | string) => {
  return SuggestionNclicks[type.toUpperCase()]
}
